import React from 'react'

const Rules = () => {
    return (
        <>
            <h2>Mog House Rules kupo!</h2>
            <header>
                <div id='container'>

                    <ol>
                        <li>No offensive messages or nicknames. All Text channels In Game & Discord are PG-13.</li>
                        <li>No spam, this includes loud/obnoxious noises in voice, @mention spam, character spam, image spam, and message spam.</li>
                        <li>No Gorey, Sexual, or scary content - Screamer links, porn, nudity, death.</li>
                        <li> No harassment - Including sexual harassment or encouraging of harassment.</li>
                        <li>Use the appropriate channels.</li>
                        <li>No self or user bots - These are in some cases against the discord TOS. Moghouse uses Kupobot & Meee6. They are channel Specific due to same prefix (!).</li>
                        <li>Swearing is allowed in Voice Chats but no cursing at each other. Keep it Professional.</li>
                        <li> There may be situations not covered by the rules or times where the rule may not fit the situation. If this happens the moderators are trusted to handle the situation appropriately.</li>
                    </ol>
                </div>
            </header>
        </>
    )
}

export default Rules